// /utils/Socket.js

import { io } from "socket.io-client";

import { normalizeSocketBaseUrl } from "./resolveSocketIoNamespaceUrl.js";

const SOCKET_RAW = process.env.SOCKET_IO;
const BASE_URL_RAW =
  typeof SOCKET_RAW === "string" && SOCKET_RAW.trim()
    ? normalizeSocketBaseUrl(SOCKET_RAW.trim())
    : "";

const BASE_URL =
  BASE_URL_RAW && BASE_URL_RAW.includes("://")
    ? new URL(BASE_URL_RAW).origin
    : BASE_URL_RAW
      ? new URL(`http://${BASE_URL_RAW}`).origin
      : "";

if (!BASE_URL) {
  throw new Error(
    "[Socket] SOCKET_IO is required at build time (webpack DefinePlugin / .env.local)."
  );
}

const MANUAL = {
  withCredentials: true,
  transports: ["websocket"],
  upgrade: false,
  autoConnect: false,
  reconnection: true,
  reconnectionAttempts: Infinity,
  reconnectionDelay: 0,
  reconnectionDelayMax: 0,
  timeout: 3000,
  forceNew: true,
  closeOnBeforeunload: true
};

const AUTO = {
  ...MANUAL,
  autoConnect: true,
};

// Chat namespace (manual only)
const systemSocket = io(`${BASE_URL}/system`, AUTO);

// Chat namespace (manual only)
const chatSocket = io(`${BASE_URL}/chat`, MANUAL);

// appProcess namespace (manual only)
const appProcessSocket  = io(`${BASE_URL}/appProcess`, MANUAL);

// chat-status namespace (manual only)
const chatStatusSocket = io(`${BASE_URL}/chat-status`, MANUAL);

// Votes namespace (manual only)
const voteSocket = io(`${BASE_URL}/votes`, MANUAL);

// Lexical collaboration (manual only)
const collabSocket = io(`${BASE_URL}/collab`, MANUAL);

// MCQ namespace (manual only)
const mcqSocket = io(`${BASE_URL}/academy-mcq`, MANUAL);

// Officer Checklist namespace (manual only)
const checklistSocket = io(`${BASE_URL}/academy-checklist`, MANUAL);

// Courses namespace (manual only)
const courseSocket = io(`${BASE_URL}/academy-course`, MANUAL);

// Auth namespace (manual control only)
const authSocket = io(`${BASE_URL}/auth`, MANUAL);

// Security namespace (manual control only)
const securitySocket = io(`${BASE_URL}/security`, MANUAL);

// Notifications namespace (manual control only)
const notificationsSocket = io(`${BASE_URL}/notifications`, MANUAL);

// Roster (members roster page — manual connect + resume)
const rosterSocket = io(`${BASE_URL}/roster`, MANUAL);

// Personal hub sections (factions reputations, hangar — manual connect + resume)
const personalHubSocket = io(`${BASE_URL}/personal-hub`, MANUAL);

// Calendar grid (manual connect + resume; replaces polling /api/admin/retrieve-event-for-period)
const calendarSocket = io(`${BASE_URL}/calendar`, MANUAL);

// Event planner (manual connect + resume; per occurrence room)
const eventPlannerSocket = io(`${BASE_URL}/event-planner`, MANUAL);

// Event auctions (manual connect + resume; full-state snapshots per occurrence)
const eventAuctionSocket = io(`${BASE_URL}/event-auctions`, MANUAL);

// Admin organisation members — structure change requests (manual connect + resume)
const orgStructureChangeRequestsSocket = io(
  `${BASE_URL}/org-structure-change-requests`,
  MANUAL
);

// Admin organisation members — internal position applications (manual connect + resume)
const orgPositionApplicationsSocket = io(
  `${BASE_URL}/org-position-applications`,
  MANUAL
);

// Event template editor (broadcast-only real-time sync; manual connect)
const eventTemplateSocket = io(`${BASE_URL}/event-template`, MANUAL);

// Org funding gauge (secondary nav — manual connect + resume)
const fundingSocket = io(`${BASE_URL}/funding`, MANUAL);

// Support choice popup after Ko-fi donation (manual connect + resume)
const supportChoiceSocket = io(`${BASE_URL}/support-choice`, MANUAL);

// Guest access requests (identity check + secondary-nav admin review)
const guestAccessRequestsSocket = io(`${BASE_URL}/guest-access-requests`, MANUAL);

// ---------------------------------------------------------
// 🌟 NEW: Status namespace (auto connect globally)
// ---------------------------------------------------------
const statusSocket = io(`${BASE_URL}/status`, {
  ...AUTO,
  withCredentials: false,
});

// Version namespace — auto connect for all visitors (VersionContext emits hello on connect)
const versionSocket = io(`${BASE_URL}/version`, {
  ...AUTO,
  withCredentials: false,
});

if (typeof window !== "undefined") {
  window.statusSocket = statusSocket;
}

export {
  systemSocket,
  versionSocket,
  chatSocket,
  chatStatusSocket,
  appProcessSocket,
  voteSocket,
  collabSocket,
  mcqSocket,
  checklistSocket,
  courseSocket,
  authSocket,
  securitySocket,
  notificationsSocket,
  rosterSocket,
  personalHubSocket,
  calendarSocket,
  eventPlannerSocket,
  eventAuctionSocket,
  orgStructureChangeRequestsSocket,
  orgPositionApplicationsSocket,
  statusSocket,
  eventTemplateSocket,
  fundingSocket,
  supportChoiceSocket,
  guestAccessRequestsSocket,
};
